import {createNamespacedHelpers} from "vuex";

const { mapGetters, mapActions } = createNamespacedHelpers('psdLayers')
export default {
  data: () => ({
    truncateTextThreshold: 20,
    isTooltipShown: false,
    name: undefined,
  }),
  created() {
    this.name = this.node?.data?.name
  },
  methods: {
    ...mapActions([
      'setNodeChanges',
    ]),
    changeLayerName(newName) {
      this.name = newName
      const nodeId = this.node.uuid;

      this.setNodeChanges({
        nodeId: nodeId,
        changes: [
          {key: 'data.name', value: newName},
          {key: 'name', value: newName}
        ]
      });
    },
    truncateFieldName(fieldName) {
      if (this.isNotTruncated(fieldName)) {
        return fieldName;
      }

      return `${fieldName.slice(0, 9).trim()}...${fieldName.slice(-9).trim()}`;
    },
    isNotTruncated (text) {
      return !this.isTooltipShown && text.length < this.truncateTextThreshold
    },
  }
}
